import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import { WifiPackagesStore } from 'mobx-store/stores/wifiPackagesStore';

interface IProps extends WithSnackbarProps {
  wifiPackagesStore: WifiPackagesStore;
  history: any;
}

@inject('wifiPackagesStore')
@observer
class WifiPackagesScreen extends Component<IProps> {
  title: string = translate('wifiPackagesPageTitle');

  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  tableData: any[] = [];

  constructor(props: IProps) {
    super(props);
    this.addButton = this.getAddWifiPackagesButton();
    this.tableHeader = this.getWifiPackagesTableHeader();
    this.tableCellTypes = this.getWifiPackageTableCellTypes();
  }


  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/wifi-packages/${this.props.wifiPackagesStore.wifiPackagesList[index].packageId}/edit`,
    );
  };

  handelAdd = (): void => {
    this.props.history.push('/wifi-packages/new');
  };

  getAddWifiPackagesButton = () => ({
    title: translate('addButton'),
    onAdd: this.handelAdd,
  });

  getWifiPackagesTableHeader = () => [
    {
      title: translate('name'),
    },
    {
      title: translate('Status'),
    },
    {
      title: translate('editButton'),
    },
  ];

  getWifiPackagesTableData = () => this.props.wifiPackagesStore.wifiPackagesList
    .map((wifiPackage) => ({
      ...wifiPackage, edit: translate('editButton'),
    }));

  getWifiPackageTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'name',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',  
      activeLabel: translate('FormActiveLabel'),
      inactiveLabel: translate('FormNotActiveLabel'),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];
  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    const wifiPackage = this.props.wifiPackagesStore.wifiPackagesList[index];
    this.props.wifiPackagesStore.updateWifiPackage({isActive: value, name: wifiPackage.name, packageOptions: wifiPackage.wifiPackageOption}, wifiPackage.packageId)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage'), 8000, 'success');
        this.props.wifiPackagesStore.wifiPackagesList[index].isActive = value;
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage'), 8000, 'error');
      });
  };

  render() {
    this.tableData = this.getWifiPackagesTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('emptyTable')}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loading={this.props.wifiPackagesStore.loading}
          loadingStatus={[
            this.props.wifiPackagesStore.state,
          ]}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.wifiPackagesStore.getWifiPackages();
  }
}

export default WifiPackagesScreen;
